// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ClientSortSpec
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceSortDirection } from "abweb/dto/generated/ds/DataSourceSortDirection";
export class ClientSortSpecBase {
  /** Do NOT invoke directly, instead use strongly typed createClientSortSpecBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ClientSortSpec";
  }
  initFromJson(json, deserializeContext) {
    this.initClientSortSpec(json.direction != null ? DataSourceSortDirection.fromJson(json.direction) : null, json.fieldPath != null ? json.fieldPath : null);
  }
  initClientSortSpec(direction, fieldPath) {
    this._direction = direction;
    this._fieldPath = fieldPath;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["direction"] = this._direction;
    retVal["fieldPath"] = this._fieldPath;
    return retVal;
  }
  get direction() {
    return this._direction;
  }
  set direction(value) {
    this._direction = value;
  }
  get fieldPath() {
    return this._fieldPath;
  }
  set fieldPath(value) {
    this._fieldPath = value;
  }
}
//# sourceMappingURL=ClientSortSpecBase.js.map
